<template>
  <div class="headNav_main" :style="navStyle">
    <div class="headNav">
      <router-link to="/" class="logo" data-text="AIOTEC">AIOTEC</router-link>
      <div
        class="route"
        @click="goPage(route.path)"
        v-for="route in allRoutes.children"
        :key="route.name"
        :style="{ color: routeName == route.name ? '#8c8c8d' : '' }"
      >
        {{ route.meta.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allRoutes: this.$router.options.routes[0],
      navStyle: {
        backgroundColor: "rgba(59, 64, 78, 0.4)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        color: "#fff",
      },
      routeName: " ",
    };
  },
  mounted() {
    this.routeName = this.$route.name;
    window.addEventListener("scroll", this.handleScroll);
    console.log(this.$route);
  },
  watch: {
    $route(value) {
      console.log(value.name);
      this.routeName = value.name;
      if (value.name == "homePage") {
        this.navStyle.backgroundColor = "rgba(59, 64, 78, 0.4)";
        this.navStyle.color = "#fff";
      } else {
        this.navStyle.backgroundColor = "rgba(255,255,255, 0.4)";
        this.navStyle.color = "#000";
        this.navStyle.boxShadow = "0px 5px 5px rgba(0, 0, 0, 0.09)";
      }
    },
  },
  methods: {
    goPage(path) {
      this.path = path;
      this.$router.push(this.path);
    },
    // handleScroll() {
    //   const scrollTop =
    //     window.pageYOffset || document.documentElement.scrollTop;
    //   const opacity = Math.min(0.6, 0.4 + scrollTop / 300);
    //   const isColor = scrollTop > 50 && this.$route.name !== "homePage";
    //   this.navStyle = {
    //     ...this.navStyle,
    //     backgroundColor: isColor
    //       ? `rgba(255,255,255, ${opacity}) `
    //       : `rgba(59, 64, 78, ${opacity})`,
    //     backdropFilter: isColor ? "blur(10px)" : "blur(5px)",
    //     WebkitBackdropFilter: isColor ? "blur(10px)" : "blur(5px)",
    //     color: isColor ? "#000" : "#fff",
    //     boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.09)",
    //   };
    // },
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const isHomePage = this.$route.name === "homePage";
      const opacity = Math.min(0.6, 0.4 + scrollTop / 300);
      const isColor = scrollTop > 50;
      this.navStyle = {
        ...this.navStyle,
        backgroundColor: isHomePage
          ? isColor
            ? `rgba(255,255,255, ${opacity})`
            : `rgba(59, 64, 78, ${opacity})`
          : `rgba(255,255,255, ${opacity})`,
        backdropFilter: isColor ? "blur(10px)" : "blur(5px)",
        WebkitBackdropFilter: isColor ? "blur(10px)" : "blur(5px)",
        color: isHomePage ? (isColor ? "#000" : "#fff") : "#000",
        boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.09)",
      };
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
a {
  text-decoration: none;
}
.router-link-active {
  text-decoration: none;
}
.headNav_main {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  transition: all 0.3s ease;
}

.headNav {
  padding: 20px;
  display: flex;
  align-items: center;
  margin-left: 20px;
  .logo {
    font-weight: bold;
    font-size: 20px;
    margin: 0;
    margin-right: 10px;
    color: #7aa5e1;
    font-family: auto;
    position: relative;
  }
  .logo::before {
    content: attr(data-text);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: transparent;
    background: linear-gradient(
      135deg,
      transparent 0%,
      transparent 40%,
      rgba(255, 255, 255, 0.9) 50%,
      transparent 60%,
      transparent 100%
    );
    background-size: 300% 300%;
    background-position: 0% 0%;
    -webkit-background-clip: text;
    background-clip: text;
    animation: lightSweep 3s ease-in-out infinite;
  }

  @keyframes lightSweep {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: 100% 100%;
    }
  }
}

/* .logo {
  font-weight: bold;
  font-size: 20px;
  margin-right: 30px;
  color: #7aa5e1;
  position: relative;
} */

.route {
  cursor: pointer;
  margin-right: 30px;
  transition: opacity 0.3s;
  font-size: 15px;
}

.route:hover {
  opacity: 0.8;
}
</style>
